import type { IconProps } from './icons.types';

export function AddIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" />
    </svg>
  );
}
